// extracted by mini-css-extract-plugin
export var hiddenFileInputField = "styles-module--hiddenFileInputField--3Mc_f";
export var smallText = "styles-module--smallText--2I80i";
export var largeText = "styles-module--largeText--3cfZO";
export var videoListItem = "styles-module--videoListItem--3saZT";
export var listItem = "styles-module--listItem--2g-p6";
export var boldFont = "styles-module--boldFont--1cHGk";
export var offColorText = "styles-module--offColorText--2k2Mg";
export var extraLargeText = "styles-module--extraLargeText--nVyQa";